<template>
	<div class="head-serch">
		<el-form class="form" ref="searchFormDom" :model="searchForm" label-width="100px" @submit.native.prevent @keyup.enter.native="searchHandler">
			<el-form-item label="名称">
				<el-input v-model="searchForm.deviceType" placeholder="设备类型" />
			</el-form-item>
		</el-form>
		<el-button class="filter-item" size="mini" type="success" icon="el-icon-search" @click="searchHandler">搜索</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			searchForm: {
				deviceType: ''
			}
		};
	},
	created() {},
	methods: {
		searchHandler() {
			this.$emit('searchForm', this.searchForm);
		}
	}
};
</script>

<style>
.form {
	display: flex;
}
</style>
